import { CSSProperties } from 'react';

interface LoaderProps {
    size?: number;
    color?: string;
    style?: CSSProperties;
}

const Loader = ({ size = 24, color = 'var(--primary)', style }: LoaderProps) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            style={{ animation: 'spin 0.8s linear infinite', ...style }}
        >
            <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
            <circle
                cx="12"
                cy="12"
                r="10"
                fill="none"
                stroke={color}
                strokeWidth="3"
                strokeLinecap="round"
                strokeDasharray="32"
                strokeDashoffset="0"
            />
        </svg>
    );
};

export default Loader;
